import { IEventPublisher } from '@cp/shared/cqrs';
import { IModalDescription, IModalManager, IModalProps, LayoutConfig, ModalIdentifier, ModalStat } from '@cp/shared/modal';
import { RefObject } from 'react';

export class RefModalManager implements IModalManager {
  #ref: RefObject<IModalManager> | null = null;
  #statsRef: RefObject<ModalStat> | null = null;

  constructor(eb: IEventPublisher) {
    eb.subscribe({ name: 'page-view' }, () => this.#closeAll());
  }

  #closeAll() {
    if (!this.stats.size) {
      return;
    }
    console.log('Close all modals due page navigation');
    this.stats.forEach((m) => {
      this.close(m.uniqId);
    });
  }

  connect(ref: RefObject<IModalManager>) {
    this.#ref = ref;
  }

  disconnect() {
    this.#ref = null;
    this.#statsRef = null;
  }

  connectStats(ref: RefObject<any>) {
    this.#statsRef = ref;
  }

  get stats(): ModalStat {
    return this.#statsRef?.current || new Set();
  }

  open<M extends IModalDescription<P>, P extends IModalProps<Parameters<P['onSuccess']>[0]>>(
    modal: M,
    props: P,
    parent?: ModalIdentifier,
    layout?: LayoutConfig,
  ) {
    if (!this.#ref?.current) {
      throw new Error('Modal manager is not connected');
    }
    return this.#ref.current.open(modal, props, parent, layout);
  }
  close(uniqId: ModalIdentifier) {
    if (!this.#ref?.current) {
      throw new Error('Modal manager is not connected');
    }
    return this.#ref.current.close(uniqId);
  }
}
